import { usePage } from 'client/store'
import pageSelectors from 'client/store/page/pageSelectors'
import EntityTypeEnum from 'common/enums/entityTypeEnum'

export const useCheckWebsiteHeaderParent = (parentId: string = ''): boolean => {
  return (
    usePage(page => pageSelectors.getEntityById(page, parentId || ''))?.type ===
    EntityTypeEnum.WebsiteHeader
  )
}
